import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Loader, Dimmer, Table, Label, Accordion, List} from 'semantic-ui-react';
import {commonColors} from '../../../../common/constants/colors';
import {sortDealersNames} from '../../../utils';
import {Actions} from '../../../../common/actions';
import ProgressBar from '../../../../common/components/progressBar';
import ModelsTable from './ModelsTable';
import PartsTable from './PartsTable';
import TasksTable from './TasksTable';

class TablesCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndex': 0,
    };
  }

   handleClick = (e, titleProps) => {
     const {index} = titleProps;
     const {activeIndex} = this.state;
     const newIndex = activeIndex === index ? -1 : index;
     this.setState({'activeIndex': newIndex});
   }

  renderLoaders = () => {
    const {loadingExcelFile, loadingChassisExcelFile} = this.props;

    if (loadingExcelFile || loadingChassisExcelFile) {
      return (
        <Dimmer active inverted>
          <Loader indeterminate>
            {loadingExcelFile ? 'Cargando archivo' : 'Descargando archivo'}
          </Loader>
        </Dimmer>
      );
    }

    return (
      <Card raised fluid className='campaign-table'>
        <Table striped className='toyota-grid'>
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan='100%'>
                <Loader active inline='centered' content='Cargando informacion' />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Card>
    );
  }

  renderDealersProgress = (dealersArray) => {
    if (dealersArray && dealersArray.length) {
      const sortedDealers = sortDealersNames(dealersArray);
      return sortedDealers.map((dealer, idx) => {
        return (
          <List.Item className='campaign-total'>
            <List.Content className='label-content' floated='left'>
              <Label key={idx} color={commonColors[idx]} size='large'>
                {dealer.dealerName.toUpperCase()}
              </Label>
            </List.Content>
            <List.Content
              floated='right'
              className={!dealer.dealerDocument ? 'label-content' : ''}
            >
              {dealer.dealerDocument && (
                <ProgressBar
                  key={idx}
                  label='TWC'
                  partialQuantity={dealer.totalWarrantiesByDealer}
                  totalQuantity={dealer.totalChassisByDealer}
                  mediumPercent={79}
                  lowPercent={35}
                />
              )}
              {!dealer.dealerDocument && (
                <Label
                  key={idx}
                  color={commonColors[idx]}
                  size='large'
                >
                  {dealer.totalChassisByDealer}
                </Label>
              )}
            </List.Content>
          </List.Item>
        );
      });
    }
    
    return <p>No se encuentran concesionarios disponibles</p>;
  }

  render() {
    const {
      task,
      model,
      edit,
      part,
      campaign,
      isUserTde,
      isLoading,
      campaingNo,
      tasksArray,
      partsArray,
      chassisArray,
      dealersArray,
      loadingTask,
      loadingPart,
      loadingModel,
      loadingTasksArray,
      loadingPartsArray,
    } = this.props;

    const {activeIndex} = this.state;

    return (
      <>
        {isLoading && this.renderLoaders()}

        {!isLoading && edit && (
          <>
            <Card raised fluid>
              <div className='campaign-info-container'>
                <h3>Avance de campañas por concesionario:</h3>
                <List relaxed divided selection animated verticalAlign='middle' size='big'>
                  {this.renderDealersProgress(dealersArray)}
                </List>
              </div>
            </Card>
            <Accordion fluid styled>
              <Accordion.Title
                active={activeIndex === 0}
                index={0}
                onClick={this.handleClick}
                icon='dropdown'
                content='Tabla Chassis'
              ></Accordion.Title>
              <Accordion.Content active={activeIndex === 0}>
                <Card raised fluid className='campaign-table'>
                  <ModelsTable dataTable={chassisArray} isUserTde={isUserTde} />
                </Card>
              </Accordion.Content>
              <Accordion.Title
                active={activeIndex === 1}
                index={1}
                onClick={this.handleClick}
                icon='dropdown'
                content='Tabla Partes'
              ></Accordion.Title>
              <Accordion.Content active={activeIndex === 1}>
                <PartsTable
                  dataTable={partsArray}
                  isUserTde={isUserTde}
                  part={part}
                  campaign={campaign}
                  campaingNo={campaingNo}
                  loadingPart={loadingPart}
                  loadingPartsArray={loadingPartsArray}
                />
              </Accordion.Content>
              <Accordion.Title
                active={activeIndex === 2}
                index={2}
                onClick={this.handleClick}
                icon='dropdown'
                content='Tabla Trabajos'
              ></Accordion.Title>
              <Accordion.Content active={activeIndex === 2}>
                <TasksTable
                  dataTable={tasksArray}
                  isUserTde={isUserTde}
                  task={task}
                  campaingNo={campaingNo}
                  loadingTask={loadingTask}
                  loadingTasksArray={loadingTasksArray}
                  model={model}
                  loadingModel={loadingModel}
                />
              </Accordion.Content>
            </Accordion>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'campaign': state.campaign.campaign,
    'chassisArray': state.campaignChassis.chassisArray,
    'dealersArray': state.campaignChassis.dealersArray,
    'loadingPartsArray': state.campaignParts.loading,
    'partsArray': state.campaignParts.partsArray,
    'part': state.campaignParts.part,
    'loadingPart': state.campaignParts.loadingPart,
    'loadingTasksArray': state.campaignTasks.loading,
    'tasksArray': state.campaignTasks.tasksArray,
    'task': state.campaignTasks.task,
    'loadingTask': state.campaignTasks.loadingTask,
    'loadingModel': state.campaignTasks.loadingModel,
    'model': state.campaignTasks.model,
  };
};

const {
  withRouter,
  navigateTo,
  addCampaign,
  loadingExcel,
  clearCampaign,
  updateCampaign,
  getCampaignById,
  addMessageBoxError,
  processCampaignChassis,
} = Actions;

const mapDispatchToProps = {
  navigateTo,
  addCampaign,
  loadingExcel,
  clearCampaign,
  updateCampaign,
  getCampaignById,
  addMessageBoxError,
  processCampaignChassis,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TablesCampaign)
);
